"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticTooltipNovoDark = exports.staticTooltipNovo = exports.staticTooltip = void 0;
const polished_1 = require("polished");
const styled_components_1 = require("styled-components");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const animation = (0, styled_components_1.keyframes) `
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  70% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const fadeInAnimation = (0, styled_components_1.css) `
  animation: ${animation} ${timing_const_1.default.fast} ease-in;
`;
// Classic
const staticTooltip = {
    animation: fadeInAnimation,
    backgroundColor: color_const_1.default.cloudyBlue100,
    borderWidth: size_const_1.default.borderSizeDefault,
    borderStyle: 'solid',
    borderColor: color_const_1.default.cloudyBlue300,
    borderRadius: size_const_1.default.borderRadiusSmall,
    boxShadow: `1px 1px 0 ${(0, polished_1.rgba)(color_const_1.default.pickledBluewood800, 0.1)}`,
    color: color_const_1.default.pickledBluewood800,
    fontSize: font_const_1.default.sizeXs,
    fontFamily: font_const_1.default.family,
    lineHeight: font_const_1.default.lineHeightXs,
    fontWeight: font_const_1.default.weightDefault,
    margin: size_const_1.default.small,
    maxHeight: '126px',
    maxWidth: '256px',
    padding: size_const_1.default.default,
    zIndex: zIndex_const_1.default.z4000,
    letterSpacing: 'normal',
    textAlign: 'center',
    // theme prop which controls the rendering of the tooltip arrow
    // defaults as disabled for classic theme
    enableArrow: false,
    // 11.31px square has a diagonal of aprox 16px
    // rotated to 45deg we obtain a rombus with a height and width of 16px
    arrowSize: '11.31px',
    arrowBorderRadius: size_const_1.default.borderRadiusSmall,
    // used to properly place the arrow relative to the tooltip box - we compensate for border width as well
    arrowMarginOffset: '-6.8px',
};
exports.staticTooltip = staticTooltip;
// Novo
const staticTooltipNovo = {
    ...staticTooltip,
    // novo themes have tooltip arrow enabled
    enableArrow: true,
    borderStyle: 'none',
    borderRadius: '6px',
    arrowBorderRadius: '2px',
    arrowMarginOffset: '-5.5px',
    maxWidth: '240px',
    textAlign: 'left',
    // typography
    ...novo.body01,
    backgroundColor: novo.ui10,
    boxShadow: `0px 1px 2px ${(0, polished_1.rgba)(novo.ui04, 0.25)}`,
    color: novo.textColor06,
    padding: `${novo.spacing02} ${novo.spacing03}`,
};
exports.staticTooltipNovo = staticTooltipNovo;
// Novo Dark
const staticTooltipNovoDark = {
    ...staticTooltipNovo,
    backgroundColor: novoDark.ui10,
    boxShadow: `0px 1px 2px ${(0, polished_1.rgba)(novoDark.ui04, 0.25)}`,
    color: novoDark.textColor06,
};
exports.staticTooltipNovoDark = staticTooltipNovoDark;
